import { Button } from "antd";
import React from "react";

import "./PrimaryButton.scss";

export default function PrimaryButton({ label, className = "", icon, hidden = false, ...otherProps }) {
  return (
    <Button
      className={`button-container ${className} ${otherProps.disabled ? "disabled-button" : ""}`}
      {...otherProps}
      type="primary"
      hidden={hidden}
    >
      {icon}
      {label}
    </Button>
  );
}
